import { adjustPointToHeight } from "../classes/Player.js";
import { isUpwardFacingIntersect } from '../../utils/intersections/utils.js';

export class PlayerHandlerService {

	player = null;

	static $inject = [ "$rootScope","$compile","$User","Notification","stateIndicatorService","catalogsService","$oeuvresHandler", "spherical360SetupService" ]; // jshint ignore:line

	constructor( $rootScope, $compile, $User, Notification, stateIndicatorService, catalogsService, $oeuvresHandler, spherical360SetupService ) {

		this.stateIndicatorService = stateIndicatorService;
		this.catalogsService = catalogsService;
		this.$oeuvresHandler = $oeuvresHandler;

		var self = this;

		$rootScope.$on( "player.$$walkedTowardsWall", (function( _timeout, _notification ){
			return function( player ) {
				if (_timeout) {
					clearTimeout( _timeout );
					_timeout = setTimeout( clear, 250 );
				} else if (!_notification) {
					_notification = Notification.warning({
						title: "Törmäsit seinään!",
						delay: 3600000
					}).then(init);
				}
			}

			function init( scope ) {
				_notification = scope;
				_timeout = setTimeout( clear, 250 );
			}

			function clear() {
				if (_notification) _notification.kill();
				_timeout = null;
				_notification = null;
			}
		})());

		this.init = function( player_opts ) {

			return Promise.all([
				$rootScope.__artestUserBar_ready.promise,
				$User.__ready.promise
			]).catch(function( error ){
				console.error( error );
			}).then(function() {

				player_opts = player_opts || {};

				try {

					angular.extend( player_opts, JSON.parse( localStorage.getItem( "model-preview/player-settings" )));

				} catch( err ) {
					console.error( err );
				}

				$rootScope.player = self.player = new Player( JSON.parse( JSON.stringify( player_opts )));

			}).then(function() {


				/********************
				 * Sijoitetaan yläpalkkiin näkymävalikko
				 */

				var view_ctrl_btn;
				try {
					/** Varmistetaan, että yläpalkissa on painike poispääsemiseksi, mutta vain jos käyttäjä on kirjautunut! */

					var view_ctrl_btn_wrapper = $( "#artestUserBar .navbar-header ul.leftie-btn-wrapper" );

					view_ctrl_btn = $( "li.viewControlDropdown-btn", view_ctrl_btn_wrapper );

					if (!view_ctrl_btn[0]) {

						if ($User.logged) {

							let _li = $( `<li class="useleft viewControlDropdown-btn" uib-dropdown>
								<a uib-dropdown-toggle>{{ 'Click to change camera mode'|translate }} <b class="caret"></b></a>
								<ul uib-dropdown-menu>

									<li ng-class="{ active: player.movement_strategy == 'default' && player.camera.userData.type == 'head' }">
										<a style="padding:3px 20px" ng-click="player.setCamera('head')" translate>Player camera</a>
									</li>

									<li ng-class="{ active: player.movement_strategy == 'walker' && player.camera.userData.type == 'head' }">
										<a style="padding:3px 20px" ng-click="player.initWalkerView()" translate>Click to start walker mode</a>
									</li>

									<li class="divider"></li>

									<li ng-class="{ active: player.camera.userData.type == 'bird' && player.camera.userData.lock == null }">
										<a style="padding:3px 20px" ng-click="player.setCamera('bird', null)" translate>Bird camera</a>
									</li>

									<li ng-class="{ active: player.camera.userData.type == 'bird' && player.camera.userData.lock == 'top' }">
										<a style="padding:3px 20px" ng-click="player.setCamera('bird', 'top')" translate>Top camera</a>
									</li>

									<li ng-class="{ active: player.camera.userData.type == 'bird' && player.camera.userData.lock == 'horizontal' }">
										<a style="padding:3px 20px" ng-click="player.setCamera('bird', 'horizontal')" translate>Horizontal camera</a>
									</li>

								</ul>
							</li>` );

							view_ctrl_btn_wrapper.prepend( _li );

							$compile( _li )( $rootScope );

						} else {
							view_ctrl_btn.remove();
						}
					}
				} catch (error) {
					console.error( error );
					view_ctrl_btn && view_ctrl_btn.remove();
				}


				/** @TODO: Ihan oma systeemi yläpalkin käyttöönottamiseksi! */
				try {
					/** Varmistetaan, että yläpalkissa on painike poispääsemiseksi, mutta vain jos käyttäjä on kirjautunut! */

					var close_btn_wrapper = $( "#artestUserBar .navbar-header ul.leftie-btn-wrapper" );
					var close_btn = $( "li.endWalkerStrategy-btn", close_btn_wrapper );

					if (!close_btn[0] && $User.logged) {
						var _a  = $( '<a translate>Exit walker mode</a>' );
						let _li = $( '<li class="useleft endWalkerStrategy-btn"></li>' );
						close_btn_wrapper.append( _li.append( _a ) );

						_a.on( "click", function(){ player.setMovementStrategy( "default" ); });

						close_btn = $( "li.endWalkerStrategy-btn", close_btn_wrapper );
					} else if (!$User.logged) {
						close_btn.remove();
					}

				} catch (error) { console.error( error ); }

				return self.player
			});
		};

		this.setConfig = function setPlayerConfig( key, value) {
			try {
				$User.saveLocalConfig( "model-preview/" + key, value );
			} catch (error) {
				console.error( "ERROR@$playerHandler.setConfig", error );
			}
		};

		this.getConfig = function getPlayerConfig( key ) {
			try {
				return $User.loadLocalConfig( "model-preview/" + key );
			} catch (error) {
				console.error( "ERROR@$playerHandler.getConfig", error );
			}
		};
	}

	async doGoToIntersect( intersect ) {

		let { type, obj } = intersect && intersect.object && intersect.object.userData || {};

		// Teosta klikatessa siirrytään katsomaan sitä
		if (type == "oeuvre") {
			this.doGoToCatalogItemObject( obj );
		}
		// Lattiaa klikatessa siirrytään ko. kohtaan
		else if (type == "world") {
			this.doGoToWorldIntersect( intersect );
		}
	}

	async doGoToCatalogItemObject( object ) {

		let catalog, catalog_item;

		try {
			catalog = this.catalogsService.solveCurrentCatalog( this.catalogsService.solveCatalogs( this.catalogsService.solveCurrentArrangement() ) );

			if (catalog) {
				
				catalog_item = catalog.solveItemByObject( object, catalog );

			}
		} catch (e) {}


		if (catalog_item && catalog) {
			this.stateIndicatorService.setCatalogItem( catalog_item, catalog );
		}

		return this.doGoToObject( object );
	}

	async doGoToCatalogItem( catalog_item, catalog ) {

		let object = this.catalogsService.solveItemObject( catalog_item, catalog );

		if (await this.doGoToObject( object )) {

			if (catalog_item && catalog) {

				this.stateIndicatorService.setCatalogItem( catalog_item, catalog );
			}
			
			return true;
		}

		return false;
	}

	async doGoToObject( object ) {

		if (object instanceof Oeuvre) {

			this.player.walkToLookPainting( object );

			return true;

		} else if (object.mesh) {

			this.player.walkToLookMesh( object.mesh );

			return true;
		}

		return false;
	}

	async doGoToMesh( mesh ) {

		if (mesh) {

			if (mesh.userData && mesh.userData.obj instanceof Oeuvre) {

				this.player.walkToLookPainting( mesh.userData.obj );

			} else {

				this.player.walkToLookMesh( mesh );
			}
				
			return true;
		}

		return false;
	}

	async doGoToWorldIntersect( intersect ) {

		if (isUpwardFacingIntersect( intersect )) {

			var point = adjustPointToHeight( intersect.point, this.player.height );

			if (point) {
				this.player.walkToPosition( point );
				return true;
			}
		}
	}
}
